<template>
    <div>
        <tabs-header-mobile
            route-to-name="SupplierProductsEdit"
            title="Изображения"
        />

        <form class="product-form supplier-tab">
            <edit-images
                :initial-images="product.images"
                @onImagesChange="onProductImagesChange($event)"
            />

            <div class="product-form__btn-wrap">
                <button
                    id="productImagesBtn"
                    type="button"
                    class="cabinet-btn product-form__btn"
                    :class="{ loading: loading }"
                    :disabled="
                        !needSaveImages.length ||
                            !displayedImages.length ||
                            loading
                    "
                    @click.prevent="updateImages()"
                >
                    Сохранить изменения
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import TabsHeaderMobile from '@/components/Cabinet/Tabs/TabsHeaderMobile'
import EditImages from '@/components/Cabinet/Supplier/Product/EditImages'
import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'EditImagesForm',
    components: { TabsHeaderMobile, EditImages },
    data() {
        return {
            product: {
                id: '', // indicate product was loaded
                images: []
            },
            displayedImages: [],
            needSaveImages: [],
            loading: false
        }
    },
    computed: {
        ...mapGetters('supplierProducts', ['getFormattedProduct'])
    },
    watch: {
        getFormattedProduct: {
            handler: function(val) {
                if (!this.product.id && Object.keys(val).length) {
                    this.setProductFields()
                }
            },
            deep: true
        }
    },
    mounted() {
        if (Object.keys(this.getFormattedProduct).length) {
            this.setProductFields()
        }
    },
    methods: {
        ...mapActions('supplierProducts', ['updateProduct', 'getProduct']),
        setProductFields() {
            this.product = {
                ...this.getFormattedProduct
            }
        },
        onProductImagesChange($event) {
            // console.log($event)
            this.displayedImages = $event.displayedImages
            this.needSaveImages = $event.needSaveImages
        },
        async updateImages() {
            if (this.needSaveImages.length && this.displayedImages.length) {
                this.loading = true

                let data = {
                    productId: this.product.id,
                    images: this.needSaveImages.map(image => {
                        //для изображений, которые были сохранеы на бэке, и удалены при редактировании ItemImageID: 'id', url: null,
                        //для новых изображений ItemImageID: null, url: 'контент'
                        return {
                            ItemImageID: image.url ? null : image.ItemImageID,
                            image: image.url
                        }
                    })
                }

                try {
                    let payload = {
                        id: this.product.id,
                        type: 'images',
                        data
                    }
                    await this.updateProduct(payload)

                    this.$notify({
                        title: 'Продукт успешно обновлен',
                        type: 'success'
                    })
                } catch (e) {
                    console.log(e)
                    this.$notify({
                        title: 'Ошибка',
                        type: 'error'
                    })
                }

                try {
                    await this.getProduct(this.product.id)
                    this.setProductFields()
                } catch (e) {
                    console.log(e)
                }

                this.loading = false
            } else if (!this.needSaveImages.length) {
                this.$notify({
                    title: 'Нет изменений',
                    type: 'warn'
                })
            } else {
                this.$notify({
                    title: 'Добавьте изображение',
                    type: 'warn'
                })
            }
        }
    }
}
</script>
